/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
/**
 * @hidden
 */
export var UIElementPropertyId_$type = /*@__PURE__*/ markEnum('UIElementPropertyId', 'Unset,0|Opacity,1|BackgroundColor,2|BorderColor,3|BorderWidth,4|BorderRadius,5|Padding,6|Color,7|FontSize,8|Width,9|Height,10|Left,11|Top,12|Margin,13|Transform,14|Stroke,15|Fill,16|StrokeWidth,17|StrokeDashArray,18|StrokeDashOffset,19');
//# sourceMappingURL=UIElementPropertyId.js.map
